<template>
  <div class="md:w-1/2 mx-auto pt-16 pb-5 px-3">
    <div class="flex flex-row justify-center">
      <img class="w-12 mr-5" src="@/assets/images/main-logo.svg" />
      <div class="flex items-center">
        <h1 class="text-4xl font-light">Rent Application</h1>
      </div>
    </div>
    <div class="flex flex-col items-center md:flex-row justify-between py-12">
      <router-link
        tag="a"
        :to="{ name: 'home_support' }"
        class="text-brand-dark-gray py-3 hover:underline hover:text-brand-black"
        >Support desk</router-link
      >
      <router-link
        tag="a"
        :to="{ name: 'home_privacy' }"
        class="text-brand-dark-gray py-3 hover:underline hover:text-brand-black"
        >Privacy policy</router-link
      >
      <router-link
        tag="a"
        :to="{ name: 'home_terms' }"
        class="text-brand-dark-gray py-3 hover:underline hover:text-brand-black"
        >Terms of use</router-link
      >
      <router-link
        tag="a"
        :to="{ name: 'home_security' }"
        class="text-brand-dark-gray py-3 hover:underline hover:text-brand-black"
        >Security</router-link
      >
    </div>

    <div class="flex flex-col items-center md:flex-row justify-center py-5">
      <p class="text-brand-dark-gray py-3 text-center">
        © 2024 Rent Application Technology Services LLC. All rights reserved.
      </p>
    </div>
  </div>
</template>
